import React from "react";
import Button from "../../../../shared/button/button";

const SmartExtractFilterActions = () => {
	return (
		<div className="smart-extract-filter-actions">
			<Button className="smart-extract-filter-actions--buttons btn-green-sm-icon">
				<i className="smart-extract-filter-actions--buttons--icon icon-search" />
			</Button>
			<Button className="smart-extract-filter-actions--buttons btn-green-sm-icon">
				<i className="smart-extract-filter-actions--buttons--icon icon-grid" />
			</Button>
			<Button className="smart-extract-filter-actions--buttons btn-green-sm-icon">
				<i className="smart-extract-filter-actions--buttons--icon icon-filter-full" />
			</Button>
		</div>
	);
};

export default SmartExtractFilterActions;
